module.exports = __webpack_public_path__ + "img/very-helpful.8f5f1d85.gif";